import React from 'react';
import { Box, Typography, Card, CardContent, Avatar, Fade } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../design-system/tokens/colors';
import { useTranslation } from 'react-i18next';
import BiometricStepsHeader from './BiometricStepsHeader';

interface BiometricFeedbackViewProps {
  feedbackData: {
    resumo: string;
  };
}

const BiometricFeedbackView: React.FC<BiometricFeedbackViewProps> = ({ feedbackData }) => {
  const { t } = useTranslation('farm');
  const resumo = feedbackData?.resumo || 'Operação concluída.';

  return (
    <Fade in timeout={500}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '55vh', p: 3, position: 'relative', flexDirection: 'column' }}>
        <Box sx={{ width: '100%', maxWidth: 640, mx: 'auto', mb: 1 }}>
          <BiometricStepsHeader active={1} />
        </Box>
        <Card sx={{ maxWidth: 520, width: '100%', borderRadius: 4, mx: 'auto', boxShadow: `0 12px 40px ${DESIGN_TOKENS.colors.primary[200]}30`, border: `1px solid ${DESIGN_TOKENS.colors.primary[100]}` }}>
          <CardContent sx={{ p: 5, textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 1 }}>
              <Avatar sx={{ width: 80, height: 80, bgcolor: DESIGN_TOKENS.colors.primary[100], border: `3px solid ${DESIGN_TOKENS.colors.primary[200]}` }}>
                <CheckCircle sx={{ fontSize: 40, color: DESIGN_TOKENS.colors.primary[700] }} />
              </Avatar>
            </Box>

            <Typography variant="h6" sx={{ fontWeight: 700, color: DESIGN_TOKENS.colors.text.primary }}>
              {t('biometricFeedback.registrationCompleted')}
            </Typography>
            <Typography variant="body2" sx={{ color: DESIGN_TOKENS.colors.text.secondary }}>
              {resumo}
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Fade>
  );
};

export default BiometricFeedbackView;